import { atom } from "jotai";
import { isGeneratingTourAtom, isTourAlertVisibleAtom } from "./tourStateAtoms";
import { canvasNameAtom, canvasDescriptionAtom } from "../canvas";
import { nodesAtom } from "../nodes";
import { edgesAtom } from "../edges";
import { isTourableNode } from "../utils";
import type { Edge, Node } from "@xyflow/react";

/**
 * Reusable setter for starting tours
 * Encapsulates the common logic used across multiple components
 */
export const startTourSetter = atom(
  null,
  (
    get,
    set,
    params: {
      copilot: any;
      canvasName?: string;
      canvasDescription?: string | null;
      nodes?: Node[];
      edges?: Edge[];
    },
  ) => {
    const { copilot } = params;

    // Validate copilot availability
    if (!copilot) {
      console.error("copilot not available");
      return Promise.reject(new Error("copilot not available"));
    }

    // Hide tour alerts when starting tour
    set(isTourAlertVisibleAtom, false);

    // Start tour generation
    set(isGeneratingTourAtom, true);

    // Prepare tour data
    const canvasNameValue = params.canvasName ?? get(canvasNameAtom);
    const canvasDescriptionValue =
      params.canvasDescription ?? get(canvasDescriptionAtom);
    const canvasNodes = (params.nodes ?? get(nodesAtom)).filter(isTourableNode);
    const canvasEdges = params.edges ?? get(edgesAtom);

    try {
      copilot.append(
        {
          role: "user",
          content: "Use the tour tool",
        },
        {
          headers: { model: "fast" },
          data: {
            canvas: {
              name: canvasNameValue,
              description: canvasDescriptionValue,
            },
            nodes: canvasNodes,
            edges: canvasEdges,
          },
        },
      );
      return Promise.resolve();
      /* renderAnnotationNodesSetter will set isGeneratingTourAtom to false on success.
       * Doing it here will make the loader disappear too early.
       */
    } catch (error) {
      console.error("Failed to start tour:", error);
      set(isGeneratingTourAtom, false);
      return Promise.reject(error);
    }
  },
);

startTourSetter.debugLabel = "startTourSetter";
